export const COLUMNS = [
    { key: "icon", label: "Type", sortable: false },
    { key: "service", label: "Service", sortable: false },
    { key: "location", label: "Location", sortable: false },
    { key: "client", label: "Client", sortable: false },
    { key: "provider", label: "Provider", sortable: false },
    { key: "dateTime", label: "Date and time", sortable: false },
    { key: "notes", label: "Notes", sortable: false },
    { key: "status", label: "Status", sortable: false },
    { key: "total", label: "Total", sortable: false },
    { key: "action-icon", label: "", sortable: false }
];
